<script lang="ts">
    import {Button,Modal, ModalHeader,ModalBody, ModalFooter, Container,Row,Col } from "sveltestrap";
    import { Close, Modaltitle, Savechanges, Usingthegrid } from "../../../../utils/Constant/Constant";
    let open: boolean = false;
    const toggle = () => (open = !open);
</script>

<Button color="primary" on:click={toggle}>{Usingthegrid}</Button>
<Modal isOpen={open} {toggle}>
    <ModalHeader {toggle}>
        {Modaltitle}
        <Button class="btn-close" aria-label="Close" />
    </ModalHeader>
    <ModalBody class="grid-showcase">
        <Container fluid class="bd-example-row">
            <Row>
              <Col md="4"><span>.col-md-4</span></Col>
              <Col class="col-md-4 ml-auto"><span>.col-md-4 .ml-auto</span></Col>
            </Row>
            <Row>
              <Col md="3" class="ml-auto"><span>.col-md-3 .ml-auto</span></Col>
              <Col md="2" class="ml-auto"><span>.col-md-2 .ml-auto</span></Col>
            </Row>
            <Row>
              <Col md="6" class="ml-auto"><span>.col-md-6 .ml-auto</span></Col>
            </Row>
            <Row>
              <Col sm="9"><span>Level 1: .col-sm-9</span>
                <Row>
                  <Col xs="8" sm="6"><span>Level 2: .col-8 .col-sm-6</span></Col>
                  <Col xs="4" sm="6"><span>Level 2: .col-4 .col-sm-6</span></Col>
                </Row>
              </Col>
            </Row>
        </Container>
    </ModalBody>
    <ModalFooter>
        <Button color="secondary" on:click={toggle}>{Close}</Button>
        <Button color="primary" on:click={toggle}>{Savechanges}</Button>
    </ModalFooter>
</Modal>